/**
 * On Hebrew product/collection pages, marks leaf a/div/span nodes whose visible text has no Hebrew
 * with class `english` (direction: ltr via CSS).
 * Exposed as window.pdpMarkLtrEnglish for re-runs after DOM updates.
 */
(function pdpHeLtrEnglish() {
  var HEBREW =
    /[\u0590-\u05FF\u05F0-\u05F4\uFB1D-\uFB4F]/;

  function hasOnlyTextContent(el) {
    if (el.children.length > 0) return false;
    var t = el.textContent;
    return t != null && String(t).trim().length > 0;
  }

  function pdpMarkLtrEnglish() {
    var lang = (document.documentElement.getAttribute('lang') || '').trim();
    if (!lang || !/^he\b/i.test(lang)) return;
    var nodes = document.body.querySelectorAll('a, div, span');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!hasOnlyTextContent(el)) continue;
      if (el.hasAttribute('dir')) continue;
      if (el.classList.contains('english')) continue;
      var text = el.textContent.trim();
      if (!text || HEBREW.test(text)) continue;
      el.classList.add('english');
    }
  }

  window.pdpMarkLtrEnglish = pdpMarkLtrEnglish;

  function observeDomChanges() {
    if (!window.MutationObserver) return;
    var rafId = null;
    var observer = new MutationObserver(function () {
      if (rafId) return;
      rafId = window.requestAnimationFrame(function () {
        rafId = null;
        pdpMarkLtrEnglish();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      pdpMarkLtrEnglish();
      observeDomChanges();
    });
  } else {
    pdpMarkLtrEnglish();
    observeDomChanges();
  }
})();
